import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import { ResourcePageSideRailTestData, UseResourcePageSideRail } from "./types";

const CUSTOM_RULE_ID = "resourcePageSideRail";

const useResourcePageSideRail: UseResourcePageSideRail = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ResourcePageSideRailTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        showSideRail: false,
      },
    };
  }

  //   const variant = value?.data?.showSideRail ? "siderail" : "control";
  const variant = value?.data?.showSideRail ? "siderail" : "control";

  return {
    isLoading,
    variant,
    data: value?.data,
  };
};

export default useResourcePageSideRail;
